
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/default-scroll-bar.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_InputArea";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_InputArea__root","text-small-normal":"wds_1_76_1_StylableTypography__text-small-normal","text-small-thin":"wds_1_76_1_StylableTypography__text-small-thin","text-medium-normal":"wds_1_76_1_StylableTypography__text-medium-normal","text-medium-thin":"wds_1_76_1_StylableTypography__text-medium-thin","defaultScrollBar":"wds_1_76_1_defaultscrollbar__defaultScrollBar","inputArea":"wds_1_76_1_InputArea__inputArea","counter":"wds_1_76_1_InputArea__counter","status":"wds_1_76_1_InputArea__status","disabled":"wds_1_76_1_InputArea__disabled","readOnly":"wds_1_76_1_InputArea__readOnly"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




